import l from '../../../lang';
import { ReactComponent as FaceSmileIcon } from '../../../assets/icons/face-smile.svg';
import { ReactComponent as FaceNeutralIcon } from '../../../assets/icons/face-neutral.svg';
import { ReactComponent as FaceSadIcon } from '../../../assets/icons/face-sad.svg';
import './styles.scss';

type ResolutionKey = 'pending' | 'inFavour' | 'against';

const RESOLUTION_MAP: Record<string, ResolutionKey> = {
  PENDING: 'pending',
  IN_FAVOUR: 'inFavour',
  IN_FAVOR: 'inFavour',
  AGAINST: 'against',
};

const RESOLUTION_CONFIG: Record<
  ResolutionKey,
  { color: 'orange' | 'green' | 'red'; Icon: typeof FaceNeutralIcon }
> = {
  pending: { color: 'orange', Icon: FaceNeutralIcon },
  inFavour: { color: 'green', Icon: FaceSmileIcon },
  against: { color: 'red', Icon: FaceSadIcon },
};

interface ChargebackResolutionProps {
  resolution?: string | null;
}

const ChargebackResolution = ({ resolution }: ChargebackResolutionProps) => {
  if (!resolution) {
    return <span>-</span>;
  }

  const resolutionKey = RESOLUTION_MAP[resolution.toUpperCase()];
  if (!resolutionKey) {
    return <span>-</span>;
  }

  const { color, Icon } = RESOLUTION_CONFIG[resolutionKey];

  return (
    <span className={`chargeback_resolution chargeback_resolution_${color}`}>
      <Icon className="chargeback_resolution__icon" aria-hidden />
      <span>{l(`chargebacks.resolution.${resolutionKey}`)}</span>
    </span>
  );
};

export default ChargebackResolution;
